function formatCoins(value) {
  const rounded = Math.round(Number(value || 0));
  return rounded.toLocaleString('en-US');
}

function dollarsToCoins(dollars) {
  return Math.round(Number(dollars || 0) * 10);
}

function formatCoinsFromDollars(dollars) {
  return `${formatCoins(dollarsToCoins(dollars))} coins`;
}

function formatDollarAmount(amount) {
  const numeric = Number(amount || 0);
  return numeric.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
}

function formatDate(value) {
  if (!value) {
    return '';
  }

  const parsed = new Date(value);

  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return parsed.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function getTransactionLabel(item) {
  const actor = (item.actor_username || '').trim();

  switch (item.type) {
    case 'gift_income':
      return actor ? `Gift from ${actor}` : 'Gift income';
    case 'gift_purchase':
      return actor ? `Gift to ${actor}` : 'Gift purchase';
    case 'message_income':
      return actor ? `Paid message from ${actor}` : 'Paid message income';
    case 'message_purchase':
      return actor ? `Paid message to ${actor}` : 'Paid message purchase';
    case 'message_refund':
      return actor ? `Refund from ${actor}` : 'Message refund';
    case 'deposit':
      return 'Balance top up';
    case 'withdrawal':
      return 'Withdrawal';
    case 'welcome_bonus':
      return 'Welcome bonus';
    default:
      return item.type || 'Transaction';
  }
}

function getQrUrl(targetUrl) {
  return `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(
    targetUrl
  )}`;
}

export {
  dollarsToCoins,
  formatCoins,
  formatCoinsFromDollars,
  formatDate,
  formatDollarAmount,
  getQrUrl,
  getTransactionLabel,
};